import { ActionAny, createActions } from 'src/utils/createActions';
import { SiteLanguages } from 'src/types/values/siteLanguage';

export type SiteLanguagesChangeLanguageActions =
    ActionAny<SiteLanguages, SiteLanguages>;
export const SITE_LANGUAGES_CHANGE_LANGUAGE_ACTIONS =
    createActions<SiteLanguages, SiteLanguages>('SITE_LANGUAGES_CHANGE_LANGUAGE');
